import EventCompetitions from '../eventRegistration/EventCompetitions.vue';
import NewEventRegistration from '../eventRegistration/NewEventRegistration.vue';
import RegistrationFinished from '../eventRegistration/RegistrationFinished.vue';
import RegistrationMessage from '../eventRegistration/RegistrationMessage.vue';


const router = [{
	path: '/eventRegistrationCompetitions',
	name: 'eventRegistrationCompetitions',
	component: EventCompetitions,
}, {
	path: '/newEventRegistration/:eGuid',
	name: 'newEventRegistration',
	component: NewEventRegistration,
}, {
	path: '/registrationFinished',
	name: 'registrationFinished',
	component: RegistrationFinished,
}, {
	path: '/eventregistration/confirm/:cGuid',
	name: 'confirmregistration',
	component: RegistrationMessage,
}, {
	path: '/eventregistration/remove/:rGuid',
	name: 'removeregistration',
	component: RegistrationMessage,
}];

export default router;
